import { Component, OnInit } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { TokenManager } from '../Globals';
import { LoginService } from '../services/login.service';
import { AppSession } from '../objects/Session';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  private isBusy: boolean;
  FAQList: FrequentlyAskedQuestion[];

  constructor(private workspaceService: WorkspaceService, private tokenManager:TokenManager, private loginService: LoginService, private globals: Globals, private router: Router) { }

  ngOnInit() {
    this.handleSession();
    
  }

  getFAQ(){
    this.isBusy = true;
    this.workspaceService.getFAQ().subscribe(result => {
      this.FAQList = JSON.parse(result);
      this.sortFAQ();
      this.isBusy = false;
    })
  }

  sortFAQ(){
    this.FAQList = this.FAQList.sort((a:FrequentlyAskedQuestion,b:FrequentlyAskedQuestion) => { 
      if(a.MessageOrder > b.MessageOrder){
        return 1;
      }else if(a.MessageOrder < b.MessageOrder){
        return -1;
      }else{
        return 0;
      }
     });
  }

  handleSession(){
    var sessionCookie = JSON.parse(this.tokenManager.retrieve("BRNSessionKey"));
    var self = this;
    if(sessionCookie){
      this.loginService.getSession(sessionCookie).subscribe(result => {
        if(result){
          var checkSessionObject = JSON.parse(result);
          if(checkSessionObject.SessionObject)
          {
            var sessionObject:AppSession = checkSessionObject.SessionObject;
            self.globals.Session = sessionObject;
            self.globals.CardItems = [];
            this.loginService.setSession(self.globals.Session);
            this.getFAQ();
          }
        }
      }, error => {
        this.tokenManager.store("BRNSessionKey", null);
        });
    }else{
      //this.router.navigate(['/', 'login']);
    }
  }
}

export class FrequentlyAskedQuestion {
  ID?: string;
  MessageName?: string;
  MessageHeader: string;
  MessageContent: string;
  MessageDataRetrieval?: string;
  MessageOrder: number;
}
